<template>
  <div
    style="height: 100%; min-height: 100vh"
    v-loading="loading && !isEmbedVideo"
    element-loading-text="加载中"
    element-loading-background="rgba(255, 255, 255, 0.1)"
  >
    <img
      class="embed_video_cover"
      :src="coverImg"
      v-parseImgOss="{ url: coverImg, default: 3 }"
      v-if="isEmbedVideo && !hasError && !showError"
      alt=""
    />
    <component :is="webinarView" :clientType="clientType" @hasError="handleManHasError"></component>

    <!-- 微信强制登录 -->
    <WechatForceLogin v-if="showError && isWechatForceLogin && !isEmbedPage"></WechatForceLogin>
    <!-- 其它错误 -->
    <errorPage v-else-if="showError" :prop-type="errorData.errorPageTitle">
      <template v-if="errorData.errorPageText" slot="body">
        <p>{{ errorData.errorPageText }}</p>
      </template>
    </errorPage>
  </div>
</template>
<script>
  import { Domain, useRoomBaseServer } from 'middle-domain';
  import { setPage } from '../page-config/index';
  import { removeToken } from '@vhcl/saas-login';
  import ErrorPage from './ErrorPage';
  import { getSubscribeConfigs } from './../headless/subscribe-state.js';
  import { getRoomConfigs } from './../headless/room-state.js';
  import { getEmbedVideoConfigs } from './../headless/embed-video-state.js';
  import { loadLocaleMessages } from '@/app-shared/i18n/index.js';
  import {
    removeUrlParameter,
    addParamsToUrl,
    getUrlQueryParams,
    removeUrlParamsAndUpdate
  } from '@/app-shared/utils/tool.js';
  import { saveAndSyncBothStorage } from '@vhcl/saas-login';
  export default {
    data() {
      return {
        webinarView: '',
        clientType: 'standard',
        errorData: {
          errorPageTitle: '',
          errorPageText: ''
        },
        showError: false,
        loading: true,
        coverImg: '',
        hasError: false // 活动加载出现错误
      };
    },
    components: {
      ErrorPage,
      WechatForceLogin: () => import('@/packages/wechat-force-login/pc/index.vue')
    },
    created() {
      // 日志上报的参数
      this.devLogOptions = {
        namespace: 'saas', //业务线
        env: ['production', 'pre'].includes(process.env.VUE_APP_SAAS_ENV) ? 'production' : 'test', // 环境
        method: 'post' // 上报方式
      };
      this.initRoom();
    },
    computed: {
      isEmbedPage() {
        return this.embedObj?.embed || this.embedObj?.embedVideo;
      },
      // 是否为嵌入页
      embedObj() {
        return this.$domainStore.state.roomBaseServer.embedObj;
      },
      isEmbedVideo() {
        return (
          this.$route.query.embed === 'video' ||
          location.pathname.indexOf('embedclientvideo') !== -1
        );
      },
      isWechatForceLogin() {
        return this.$domainStore.state.roomBaseServer.isWechatForceLogin;
      }
    },
    methods: {
      async initRoom() {
        try {
          console.log('%c---初始化直播房间 开始', 'color:blue');

          this.resetFileds();

          // 初始化直播房间
          const roomBaseServer = useRoomBaseServer();
          // 判断是否是嵌入/单视频嵌入

          this.coverImg = roomBaseServer.state.cover_img;
          try {
            const _param = {
              isEmbed: false,
              isEmbedVideo: false
            };
            if (location.pathname.indexOf('embedclient') !== -1) {
              _param.isEmbed = true;
              this.clientType = 'embed';
            }
            if (this.isEmbedVideo) {
              _param.isEmbedVideo = true;
            }
            roomBaseServer.setEmbedObj(_param);
          } catch (e) {
            console.log('嵌入', e);
          }
          let lang = roomBaseServer.state.languages.lang;
          const initArr = await Promise.all([
            this.initReceiveLive(this.clientType),
            loadLocaleMessages(lang?.type || 'zh')
            // roomBaseServer.getLangList({ webinar_id: this.$route.params.id }).then(() => {
            // })
          ]);

          const domain = initArr[0];

          // 不是彩排 + 预约状态 + 没有试看
          if (
            roomBaseServer.state.watchInitData.live_type != 2 &&
            this.$domainStore.state.roomBaseServer.watchInitData.status === 'subscribe' &&
            !this.$domainStore.state.roomBaseServer.watchInitData.record.preview_paas_record_id
          ) {
            const promiseList = [
              import('./Subscribe/index.vue').then(module => module.default),
              getSubscribeConfigs(),
              domain.initPassSdk({
                plugins: ['chat'],
                devLogOptions: this.devLogOptions
              }),
              setPage('subscribe')
            ];
            const result = await Promise.all(promiseList);
            this.webinarView = result[0];
            // 观看端上报
            domain.initVhallReportForWatch({
              env: ['production', 'pre'].includes(process.env.NODE_ENV) ? 'production' : 'test', // 环境，区分上报接口域名
              app_id: roomBaseServer.state.watchInitData.interact.paas_app_id,
              pf: 10 // 7：PC 10: wap
            });
          } else if (
            this.$domainStore.state.roomBaseServer.watchInitData.status === 'live' ||
            (this.$domainStore.state.roomBaseServer.watchInitData.status === 'subscribe' &&
              this.$domainStore.state.roomBaseServer.watchInitData.record.preview_paas_record_id)
          ) {
            // 如果往观看页跳转，需要清除暖场视频缓存
            window.localStorage.removeItem('warm_recordId');
            window.sessionStorage.removeItem('recordIds');
            if (this.isEmbedVideo) {
              const promiseList = [
                import('./EmbedVideo/index.vue').then(module => module.default),
                getEmbedVideoConfigs(),
                domain.initPassSdk({
                  plugins: ['chat'],
                  devLogOptions: this.devLogOptions
                }),
                setPage('embedVideo')
              ];
              const result = await Promise.all(promiseList);
              this.webinarView = result[0];
            } else {
              const promiseList = [
                import('./Live/Home.vue').then(module => module.default),
                getRoomConfigs(),
                domain.initPassSdk({
                  plugins: ['chat', 'interaction'],
                  devLogOptions: this.devLogOptions
                }),
                setPage('main')
              ];
              const result = await Promise.all(promiseList);
              this.webinarView = result[0];
            }
            // 上报wiki: http://wiki.vhallops.com/pages/viewpage.action?pageId=290882260
            domain.initVhallReport({
              bu: 0,
              user_id: roomBaseServer.state.watchInitData.join_info.join_id,
              app_id: roomBaseServer.state.watchInitData.interact.paas_app_id,
              webinar_id: this.$route.params.id,
              t_start: dayjs().format('YYYY-MM-DD HH:mm:ss'),
              os: 10,
              type: 4,
              entry_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
              pf: 7,
              env: ['production', 'pre'].includes(process.env.VUE_APP_SAAS_ENV)
                ? 'production'
                : 'test'
            });
            // 产品侧数据埋点初始化
            domain.initVhallReportForProduct({
              env: ['production', 'pre'].includes(process.env.VUE_APP_SAAS_ENV)
                ? 'production'
                : 'test', // 环境，区分上报接口域名
              app_id: roomBaseServer.state.watchInitData.interact.paas_app_id, // 产品 app id
              t_start: dayjs().format('YYYY-MM-DD HH:mm:ss'),
              pf: 8, // 客户端类型  web 网页端用 8
              user_id: roomBaseServer.state.watchInitData.join_info.join_id, // C端用户 id（如果是B端用当前用户id）
              webinar_id: this.$route.params.id // 活动 id
            });
          }
          //嵌入页
          if (this.clientType == 'embed') {
            // 告知外层 活动信息
            window.top.postMessage(
              {
                type: 'webinarInfo',
                data: {
                  webinarStatus: this.$domainStore.state.roomBaseServer.watchInitData.status, //状态：subscribe-预约，live-直播
                  webinarType: this.$domainStore.state.roomBaseServer.watchInitData.webinar.type //1-直播中，2-预约，3-结束，4-点播，5-回放
                }
              },
              '*'
            );
          }
          this.loading = false;
        } catch (err) {
          console.error('---初始化直播房间出现异常--', err);
          if (![512534, 512502, 512503, 511007].includes(Number(err.code))) {
            this.showError = true;
          }
          if (
            err.code == 511006 &&
            this.$domainStore.state.roomBaseServer?.permissionValueObj?.third_login_url
          ) {
            window.location.href = `${addParamsToUrl(
              this.$domainStore.state.roomBaseServer?.permissionValueObj.third_login_url,
              { callback_url: removeUrlParameter(window.location.href, 'token') }
            )}`;
            return;
          }
          this.handleErrorCode(err);
          this.loading = false;
        }
      },
      initReceiveLive(clientType) {
        const { id } = this.$route.params;
        const { token, rehearsal } = this.$route.query;
        if (token) {
          sessionStorage.setItem('token', token);
        }
        let stealth = 0;

        return new Domain({
          env: process.env.VUE_APP_ENV,
          requestHeaders: {
            token: clientType === 'embed' ? '' : sessionStorage.getItem('token') || ''
          },
          isNotInitPass: true,
          initRoom: {
            webinar_id: id, //活动id
            clientType: clientType, //客户端类型
            live_type: rehearsal == 1 ? 2 : 0, // 2 彩排   0 正式
            stealth, //是否创建参会记录
            ...this.$route.query // 第三方地址栏传参
          }
          // isNotInitPass: true,
        });
      },
      async handleErrorCode(err) {
        let origin =
          process.env.NODE_ENV === 'production'
            ? window.location.origin
            : 'https://t-webinar.e.vhall.com';
        switch (err.code) {
          case 512534:
            window.location.href = err.data.url; // 第三方k值校验失败 跳转指定地址
            break;
          case 512502: // 不支持的活动类型（flash）
          case 512503: // 不支持的活动类型（旧H5）
            if (this.embedObj?.embed || this.embedObj?.embedVideo) {
              let _embedQuery = location.search;
              _embedQuery =
                _embedQuery.indexOf('nickname=') != -1
                  ? _embedQuery.replace('nickname=', 'name=')
                  : _embedQuery;
              _embedQuery =
                _embedQuery.indexOf('record_id=') > -1
                  ? _embedQuery.replace('record_id=', 'rid=')
                  : _embedQuery;

              window.location.href = `${origin}/webinar/inituser/${this.$route.params.id}${_embedQuery}`;
            } else {
              window.location.href = `${origin}/${this.$route.params.id}`;
            }
            break;
          case 512002:
            this.errorData.errorPageTitle = 'active_lost'; // 此视频暂时下线了
            break;
          case 512542: // 访客数据信息不全
          case 516324:
          case 512562: // 无极版流量已达上限
          case 512543:
            this.errorData.errorPageTitle = 'video_null'; // 此视频暂时下线了
            break;
          case 512571:
            this.errorData.errorPageTitle = 'video_null'; // 流量用户欠费超过100G，暂不能进入
            break;
          case 512541:
            this.errorData.errorPageTitle = 'surpass_limit'; // 活动现场太火爆，已超过人数上限
            break;
          case 512522:
            this.errorData.errorPageTitle = 'clear_cookie'; // 主持人、嘉宾或助理直播时不能进入观看端
            break;
          case 512514:
            this.errorData.errorPageTitle = 'un_auth'; // 您已被禁止访问当前活动，被踢出直播间
            break;
          case 512588:
            this.errorData.errorPageTitle = 'embed_verify';
            this.errorData.errorPageText = this.$tec(err.code) || err.msg;
            break;
          case 512539:
            this.errorData.errorPageTitle = 'embed_verify'; // 观看页为嵌入页，设置观看限制为付费、邀请码、白名单、付费or邀请码、设置了报名报单时，访问观看页时，页面提示
            break;
          case 611001:
            this.errorData.errorPageTitle = '互动初始化失败，' + err.msg;
            break;
          case 511006: // token 校验失败，清空token，刷新页面
            this.errorData.errorPageTitle = 'embed_verify';
            this.errorData.errorPageText = this.$tec(err.code) || err.msg;
            break;
          case 511007:
            if (this.$route.query?.token) {
              this.errorData.errorPageTitle = 'embed_verify';
              this.errorData.errorPageText = this.$tec(err.code) || err.msg;
            } else {
              removeToken();
              sessionStorage.removeItem('userInfo');
              this.initRoom();
            }
            break;
          case 512573:
            this.errorData.errorPageTitle = 'email_verify';
            this.errorData.errorPageText = this.$tec(err.code) || err.msg;
            break;
          case 512912:
            // 回放视频已过观看有效期
            if (this.$route.params.id) {
              this.$router.push({
                name: 'PageError',
                params: {
                  id: this.$route.params.id,
                  code: err?.code
                }
              });
            }
            break;
          case 5100232:
            {
              if (this.isEmbedPage) {
                // 如果是嵌入页,不支持微信强制登录
                this.errorData.errorPageTitle = 'view_restriction';
                this.errorData.errorPageText = this.$tec(err.code) || err.msg;
              } else {
                if (getUrlQueryParams('open_id')) {
                  removeUrlParamsAndUpdate('open_id');
                }
                await saveAndSyncBothStorage('open_id', ''); // 兼容处理，去掉先前已经存在的open_id
                await saveAndSyncBothStorage('token', ''); // 兼容处理，去掉先前已经存在的token
                window.localStorage.removeItem('token');
                this.$domainStore.state.roomBaseServer.isWechatForceLogin = true;
                sessionStorage.setItem('wechat_force_login', 1);
              }
            }
            break;
          default:
            this.errorData.errorPageTitle = 'network';
            this.errorData.errorPageText = this.$tec(err.code) || err.msg;
        }
      },
      handleManHasError(b) {
        this.hasError = b || false;
      },
      resetFileds() {
        // 重置微信强制登录相关变量
        this.$domainStore.state.roomBaseServer.isWechatForceLogin = false;
        sessionStorage.removeItem('wechat_force_login');
      }
    }
  };
</script>
<style scoped>
  .embed_video_cover {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    object-fit: contain;
    background: #1a1a1a;
  }
</style>
